import * as Yup from "yup";

export const buildUserPasswordSchema = ({ isEditing = false, t = key => key } = {}) => {
  const suppliedPassword = Yup.string()
    .min(5, t("userModal.validation.passwordMinimum"))
    .max(50, t("userModal.validation.tooLong"));
  return Yup.string().when("userType", {
    is: "ai_agent",
    then: Yup.string().notRequired(),
    otherwise: isEditing
      ? suppliedPassword.transform(value => value === "" ? undefined : value).notRequired()
      : suppliedPassword.required(t("userModal.validation.required"))
  });
};
